module.exports = __webpack_public_path__ + "static/media/MK_logo_on_Black.33a64993.svg";